/* Collection: the friends peeking over the banner take turns hopping; sort reloads the page with the new order. */
(function () {
  'use strict';
  var WH = window.WH;
  if (!WH) return;
  WH.register('collection', function (sec) {
    var sort = sec.querySelector('[data-sort]');
    if (sort) sort.addEventListener('change', function () {
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', sort.value);
      u.searchParams.delete('page');
      window.location.href = u.toString();
    });
    var peeks = Array.prototype.slice.call(sec.querySelectorAll('[data-peek]'));
    if (!WH.anim || !peeks.length) return;
    var tl = gsap.timeline({ repeat: -1, repeatDelay: 0.8, delay: 0.8 });
    if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { if (en[0].isIntersecting) tl.resume(); else tl.pause(); }).observe(peeks[0].parentNode);
    peeks.forEach(function (p, i) {
      tl.to(p, { y: -34, scaleY: 1.08, scaleX: 0.94, duration: 0.25, ease: WH.sm('power2.out', 0.25), transformOrigin: '50% 100%' }, i * 0.9)
        .to(p, { y: 0, scaleY: 1, scaleX: 1, duration: 0.25, ease: WH.sm('power2.in', 0.25) }, i * 0.9 + 0.25)
        .to(p, { scaleY: 0.9, scaleX: 1.08, duration: 0.09, ease: 'none' }, i * 0.9 + 0.5)
        .to(p, { scaleY: 1, scaleX: 1, duration: 0.17, ease: WH.sm('power1.out', 0.17) }, i * 0.9 + 0.59);
    });
  });
})();
